import { render, staticRenderFns } from "./ProductSliderTheme1.vue?vue&type=template&id=3c8bdbd1&scoped=true"
import script from "./ProductSliderTheme1.vue?vue&type=script&lang=js"
export * from "./ProductSliderTheme1.vue?vue&type=script&lang=js"
import style0 from "./ProductSliderTheme1.vue?vue&type=style&index=0&id=3c8bdbd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8bdbd1",
  null
  
)

export default component.exports